import React, { useContext, useEffect, useState } from 'react'
import Sidebar_v2 from './sidebar/Sidebar_v2';
// import { Home } from '@mui/icons-material'
import { MyContext } from '../Context/MyContext';
import { useNavigate } from 'react-router-dom';
import Home from "./Home/Home";
import { fetchAuthSession, fetchUserAttributes } from '@aws-amplify/auth';
import TargetPage from './Home/TargetPage';
import { awsExports } from '../aws-exports';
import AWS from 'aws-sdk';
import {
  jwtTokenState, 
  rolesState,
  subState,
  tenantGroupState,
  userEmailState,
  isSuperAdminState,
  isTenantAdminRoleState,
  expState,
  firstNameState,
  displayRoleState
} from '../store/atoms';
import { atom, useRecoilState } from 'recoil';
import useLambda from './hooks/useLambda';
import { useMediaQuery } from '@mui/material';

const Main = () => {
    //const { isDarkTheme } = useContext(MyContext);
    const navigate = useNavigate();
    const [jwtToken, setJwtToken] = useRecoilState(jwtTokenState);
    const [roles, setRoles] = useRecoilState(rolesState);
    const [sub, setSub] = useRecoilState(subState);
    const [tenantGroup, setTenantGroup] = useRecoilState(tenantGroupState);
    const [userEmail, setUserEmail] = useRecoilState(userEmailState);
    const [isSuperAdmin, setisSuperAdmin] = useRecoilState(isSuperAdminState);
    const [isTenantAdminRole, setisTenantAdminRole] = useRecoilState(isTenantAdminRoleState);
    const [exp, setExp] = useRecoilState(expState);
    const [firstName, setFirstName] = useRecoilState(firstNameState);
    const [displayRole, setDisplayRole] = useRecoilState(displayRoleState);
    const { configureLambda, decodeToken, getJWT } = useLambda();
    const isMobile = useMediaQuery('(max-width:768px)');

    const [tenantMgmtFunctionName] = useState(awsExports.Lambda.userManagement);


    useEffect(() => {
      console.log('Findraiser V1');
      async function checkAuth() {
        try {
          await fetchAuthSession();
        } catch (error) {
          console.error("Not authenticated, redirecting to signin");
          navigate('/signin')
        }
    }
    checkAuth();
  }, [navigate]);

  useEffect(() => {
    const fetchRoles = async () => {
      const jwtToken = await getJWT();
      await configureLambda(jwtToken);
      const lambda = new AWS.Lambda();
       
      const payload = {
        jwtToken,
        operation: 'getRequestedTokenFields',
        requested_items: ['cognito:groups','congito:roles','exp'],
      };
          
      const stringifiedPayload = JSON.stringify(payload);
      const params = {
        FunctionName: tenantMgmtFunctionName,
        Payload: stringifiedPayload,
      };
          
      try {
        const result = await lambda.invoke(params).promise();
        const data = typeof result.Payload === 'string' ? JSON.parse(result.Payload) : result.Payload;
        const bodyData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
        // console.log('bodyData is : '+JSON.stringify(bodyData));

        if(bodyData.isSuperAdmin) {
          setDisplayRole('Global Admin');
        } else if(bodyData.isTenantAdmin) {
          setDisplayRole('Administrator');
        }

        const tenantgroup = bodyData['cognito:groups'] || [];
        let filteredGroups = tenantgroup.includes("Tenants") ? tenantgroup.filter(group => group !== 'Tenants') : [...tenantgroup];
        setTenantGroup(filteredGroups);
        setRoles(bodyData['cognito:roles'] || []);
        setisSuperAdmin(bodyData.isSuperAdmin);
        setisTenantAdminRole(bodyData.isTenantAdmin);
        setExp(bodyData.exp);
      } catch (error) {
        console.error('Error invoking getRequestedTokenFields Lambda:', error);
        throw error;
      }
    };    

    fetchRoles();

    const fetchUserName = async () => {
      try {
        const userAttributes = await fetchUserAttributes();
        setFirstName(userAttributes.given_name);
      } catch (error) {
        console.error('Failed to fetch roles:', error);
      }
    };
  
    fetchUserName();
    //console.log('data fetched and stored');
  }, []);

  
    const themeStyles = {
        // backgroundColor: isDarkTheme ? '#333' : '#FFF',
        // color: isDarkTheme ? '#FFF' : '#000',
        backgroundColor: '#FFF',
        color: '#000',
        minHeight: '100vh',
        display: "flex",
        width: "100%"
      };
  return (
    <div  className={`flex ${isMobile ? '' : 'h-screen'}`}>
    {/* Sidebar_v2 */}
    <div className="flex-shrink-0">
      {/* <Sidebar_v2 /> */}
    </div>
        {/* <Home /> */}
        {<TargetPage/>}
    </div>
  )
}

export default Main

// import React, { useContext } from 'react';
// import { MyContext } from '../Context/MyContext';
// import CurrentConversation from './Home/CurrentConversation';

// const Main = () => {
//   const { isDarkTheme } = useContext(MyContext);
//   const themeStyles = {
//     backgroundColor: isDarkTheme ? '#333' : '#FFF',
//     color: isDarkTheme ? '#FFF' : '#000',
//   };

//   return (
//     <div style={themeStyles} className="container">
//       <header className="header">Chat Application</header>
//       <CurrentConversation />
//     </div>
//   );
// };

// export default Main;
